/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LicenseBenefitSavingResponse {
    getFixupPrototypeFunction() { return LicenseBenefitSavingResponse.fixupPrototype; }

    static newInstance(model: Partial<LicenseBenefitSavingResponse>): LicenseBenefitSavingResponse {
        let obj = Object.assign(new LicenseBenefitSavingResponse(), model);
        LicenseBenefitSavingResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LicenseBenefitSavingResponse>): LicenseBenefitSavingResponse {
        if (!model) return null;
        return LicenseBenefitSavingResponse.newInstance(<LicenseBenefitSavingResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LicenseBenefitSavingResponse) {
        if (!obj) return;

        models.LicenseBenefitSavingResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LicenseBenefitSavingResponse): boolean {
        Object.setPrototypeOf(obj, LicenseBenefitSavingResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.recommendations_count === undefined) {
            this.recommendations_count = 0;
        }
        if (this.impacted_resource_count === undefined) {
            this.impacted_resource_count = 0;
        }
        if (this.savings_percentage === undefined) {
            this.savings_percentage = 0;
        }
    }

    /**
     * Recommendations Count
     */
    recommendations_count: number;

    /**
     * Impacted Resource Count
     */
    impacted_resource_count: number;

    /**
     * Potential Cost Saving
     */
    potential_cost_saving: string;

    /**
     * Savings Percentage
     */
    savings_percentage: number;

    /**
     * Potential Savings % compared to the Forecasted Spend
     */
    info: string;

}
